import { HttpInterceptorProviders } from './http-interceptor-providers';

export const CassiopeiaServiceProviders = [...HttpInterceptorProviders];
